<script lang="ts">
  import type { BeforeState } from '@pin/schemas/client-state-response';
  import { onMount } from 'svelte';
  import AlternativeList from '../components/AlternativeList.svelte';
  import Alternative from '../components/MGP/Alternative.svelte';
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';

  export let pollData: BeforeState;

  onMount(() => {
    trackEvent(
      { action: 'state:before-poll', label: pollData.title },
      pollData.id
    );
  });
</script>

<!-- svelte-ignore a11y-autofocus -->
<h2 autofocus tabindex="-1">{i18n('poll.before')}</h2>
<p>
  Følg med på direktesendingen. Når avstemningen er åpen kan du stemme på din
  favoritt.
</p>
<h2 class="artists-list-header">Artister</h2>

<AlternativeList>
  {#each pollData.alternatives as alternative, i}
    <Alternative reverse={i % 2 === 0 ? false : true} artist={alternative} />
  {/each}
</AlternativeList>

<style>
  p {
    text-align: center;
    line-height: 1.5rem;
  }
</style>
